/**
 * Extend core messages JS of Magento_Theme
 **/
define([
    'ko',
    'jquery'
], function (ko, $) {
    "use strict";

    return function (Component) {
        return Component.extend({
            /**
             * Override initialize function to add a ko bindingHandlers `scrollTo` in order to
             * monitoring the message.text change, add a ko bindingHandlers `hide` to hide
             * element after 7s
             *
             * @override
             */
            initialize: function () {
                this._super();

                ko.bindingHandlers.scrollTo = {
                    'update': (element, valueAccessor) => {
                        const offsetTop = $(element).offset().top;
                        const requireScrollHeight = 500;

                        // if message display on top half of the page,
                        // no need to scroll as user can see that
                        if (offsetTop < requireScrollHeight) {
                            return;
                        }

                        const scrollOffset = 300;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: offsetTop - scrollOffset
                        }, 1000);
                    }
                };

                ko.bindingHandlers.hide = {
                    'update': (element, valueAccessor) => {
                        setTimeout(() => {
                            $(element).hide('blind', {}, 500);
                        }, 7000);
                    }
                };
            }
        });
    };
});
